import { Contact } from '../../models/contact';

/**
 * A call link, but only where there is something to dial.
 *
 * 86 % of the numbers kept on the master records are longer than the column
 * standard allows, which is fine, and a few are notes rather than numbers
 * ("neue Firma ab 2001, Tel. stimmt noch.", measured 12.10.2026). A link built
 * from those dials whatever digits the sentence happens to contain, so a value
 * that does not read as a number is shown without one (#2229).
 */
export const paloTelHref = (value?: string | null): string | undefined => {
    if (!value) {
        return undefined;
    }

    const dialled = value.replace(/[^0-9+]/g, '');
    const looksLikeNumber = /^\+?[0-9][0-9/\s().-]*$/.test(value.trim()) && dialled.replace(/\D/g, '').length >= 6;

    return looksLikeNumber ? `tel:${dialled}` : undefined;
};

export interface PaloReachNumber {
    labelId: string;
    value: string;
}

/**
 * The numbers of a person, the one the row carries first, then whatever the
 * master record adds — each only once.
 */
export const contactPhones = (detail: Contact | null, fromRow?: string | null): PaloReachNumber[] => {
    const numbers: PaloReachNumber[] = [];
    const seen = new Set<string>();

    const add = (labelId: string, value?: string | null): void => {
        const trimmed = value?.trim();

        if (!trimmed || seen.has(trimmed)) {
            return;
        }

        seen.add(trimmed);
        numbers.push({ labelId, value: trimmed });
    };

    add('app.contacts.phone.default', detail?.phone ?? fromRow);
    // A fax is not a number anyone calls from a contact card (LST-S13 asks
    // for "Telefon und Mobil"); the rest is kept as the record has it.
    (detail?.phones ?? [])
        .filter(phone => !phone.type.endsWith('fax'))
        .forEach(phone => add(`app.contacts.${phone.type}`, phone.number));

    return numbers;
};
